
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { DatePipe } from '@angular/common';
import { formatDate } from 'src/app/shared/commen-function-file';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-employee-resignation',
  templateUrl: './employee-resignation.component.html',
  styleUrls: ['./employee-resignation.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class EmployeeResignationComponent implements OnInit {


  condidateForm!: FormGroup;
  authorities: any[] = [];
  allListingband: any = [];
  buttonColorName: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInUserRole: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserName: any | null;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  selectedYear: any;
  pmsYears: any = [];
  userEmail: any;
  updateEmployeeData: any
  withdrawalReasonCheck: any
  checkdepatment: any
  typecheck: any
  @HostListener('window:keydown.enter', ['$event'])
  handleEnterKey(event: KeyboardEvent) {
    event.preventDefault(); // Prevents the default enter key behavior
  }
  todayDate: Date = new Date();

  today = formatDate(new Date());
  checkHRSuperAdminApproval: boolean = false;
  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<EmployeeResignationComponent>,
    @Inject(MAT_DIALOG_DATA) public Employeedata: any, private config: Config, private encryptionService: EncryptionService,
    private httpService: HttpService, public dialog: MatDialog, private datePipe: DatePipe) {
    console.log("updateEmployeeData", Employeedata?.employeeData?.withdrawalAccepted);
    this.checkHRSuperAdminApproval = Employeedata?.employeeData?.withdrawalAccepted
    this.updateEmployeeData = Employeedata?.employeeData;
    this.withdrawalReasonCheck = Employeedata?.withDraw;
    this.checkdepatment = Employeedata?.depatement;
    this.typecheck = Employeedata?.type;


    this.condidateForm = this.fb.group({
      employeeName: [{ value: '', disabled: true }, Validators.required],
      department: [{ value: '', disabled: true }, Validators.required],
      band: [{ value: '', disabled: true }, Validators.required],
      grade: [{ value: '', disabled: true }, Validators.required],
      designation: [{ value: '', disabled: true }, Validators.required],
      resignationDate: [{ value: this.today, disabled: true }, Validators.required],
      status: [{ value: '', disabled: true }, Validators.required],
      noticePeriod: [{ value: '', disabled: true }, Validators.required],
      lastWorkingDate: ['', Validators.required],
      personalMailId: ['', [Validators.required, Validators.email, Validators.maxLength(100)]],
      reasonForExit: ['', Validators.required],
      exitExplanation: ['', [Validators.required, Validators.maxLength(255)]],
      contactNumber: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[0-9]{10}$/)
        ]
      ],

      hiddenReason: ['', [Validators.maxLength(255)]],
      withDraw: ['', [Validators.maxLength(255)]]

    });



  }
  ngOnInit() {
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.userEmail = sessionStorage.getItem('userEmail');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.getpmsyearlist();
  }
  hasError(controlName: any, errorType: any) {
    const control = this.condidateForm.get(controlName);
    return control?.hasError(errorType) && control.touched;
  }

  cancelbutton() {
    this.dialogRef.close();
  }
  handleInput(event: any, fieldType: string) {
    const inputElement = event.target as HTMLInputElement;

    if (fieldType === 'contactNumber' || fieldType === 'emergencyContact') {
      // Allow only numbers and restrict length to 10
      const pattern = /^[0-9]$/;
      const inputChar = event.key;

      if (!pattern.test(inputChar) || inputElement.value.length >= 10) {
        event.preventDefault();
      }
    }
  }


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;

      this.setSelectedYear(yearValue);
      // Additional function calls

      this.getNoticePeriodsForExit();
      // this.getEployeeData();
      this.getCompanyDataByCompID();
      this.getQuestions();
    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = selectedYearObj?.year;
      let test = selectedYearObj?.year.split('-');

    }
  }

  emailOfHrAdmin: any;
  getCompanyDataByCompID() {

    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {


      this.emailOfHrAdmin = data?.data?.emailOfHrAdmin;



    })
  }
  selectedOptionForExit: any;
  probstionPriodsDataForExit: any
  probationData: any = []
  getNoticePeriodsForExit() {
    this.httpService.callGetService(`${this.config.getNoticePeriods}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYear}`)
      .subscribe((record: any) => {
        console.log("API Response:", record);
        this.probationData = record?.data;

        this.getEployeeData();
      });
  }

  employeeDataForSave: any
  getEployeeData() {
    if (!this.updateEmployeeData) {

      this.httpService.callGetService(`${this.config.getEployeeData}/${this.loggedInUserCompanyID}/${this.loggedInUserId}`).subscribe((res: any) => {
        const employeeData = res.data[0];
        this.employeeDataForSave = res.data[0]
        const matchGrade = this.probationData.filter((data: any) =>
          data.grade?.trim().toLowerCase() === employeeData.grade?.trim().toLowerCase() &&
          data.band?.trim().toLowerCase() === employeeData.band?.trim().toLowerCase()
        );
        console.log(matchGrade);


        if (employeeData) {
          this.condidateForm.patchValue({
            employeeName: employeeData.empName || '',
            department: employeeData.empDept || '',
            band: employeeData.band || '',
            grade: employeeData.grade || '',
            designation: employeeData.empDesignation || '',
            status: employeeData.employmentType,
            noticePeriod: employeeData.employmentType == 'Confirmed' ? matchGrade[0]?.probationConfirmation : matchGrade[0]?.probationDuration
          });
        }
      });
    } else if (this.withdrawalReasonCheck == 'withDraw') {

      this.condidateForm.get('withDraw')?.setValidators([Validators.required]);
      this.condidateForm.patchValue({
        withDraw: this.updateEmployeeData.withdrawalReason || '',
      })
      this.condidateForm.get('withDraw')?.updateValueAndValidity();
    }

    else {
      console.log(this.updateEmployeeData && this.withdrawalReasonCheck !== 'withDraw');

      if (this.updateEmployeeData) {
        this.condidateForm.patchValue({
          employeeName: this.updateEmployeeData.empName || '',
          department: this.updateEmployeeData.empDepartment || '',
          band: this.updateEmployeeData.empBand || '',
          grade: this.updateEmployeeData.empGrade || '',
          designation: this.updateEmployeeData.empDesignation || '',
          status: this.updateEmployeeData.employmentType,
          noticePeriod: this.updateEmployeeData.noticePeriod,
          lastWorkingDate: moment(this.updateEmployeeData?.lastWorkingDay, 'DD-MM-YYYY'),
          personalMailId: this.updateEmployeeData.personalMailId,
          reasonForExit: this.updateEmployeeData.resignReason,
          exitExplanation: this.updateEmployeeData.resignReasonInDetails,
          contactNumber: this.updateEmployeeData.contactNo,
          hiddenReason: this.updateEmployeeData.secretReasonForHr

        });
      }

    }

  }
  generateKey(name: string) {
    return name.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '');
  }
  quetionsList: any;
  getQuestions() {
    this.httpService
      .callGetService(`${this.config.getQuetionsData}=${this.loggedInUserCompanyID}&year=${this.selectedYear}`)
      .subscribe((res: any) => {
        let dynamicFields: any[] = [];



        const baseFields = res.data || [];
        const customFields = this.updateEmployeeData?.customField || [];


        // 🔹 If customFields exist and not empty → use only them
        if (customFields && customFields.length > 0) {
          dynamicFields = customFields.map((cf: any) => ({
            id: cf.id || null,
            fieldName: cf.fieldName,
            fieldKey: this.generateKey(cf.fieldName),
            fieldValue: cf.fieldValue || '',
            userId: cf.userId || this.loggedInUserId,
            companyId: cf.companyId || this.loggedInUserCompanyID,
            year: cf.year || this.selectedYear,
          }));
        } else {
          // 🔹 Otherwise → merge baseFields + (empty) customFields
          dynamicFields = baseFields.map((base: any) => {
            const match = customFields.find(
              (cf: any) => cf.fieldName === base.fieldName
            );

            return {
              id: match?.id || null,
              fieldName: base.fieldName,
              fieldKey: this.generateKey(base.fieldName),
              fieldValue: match?.fieldValue || '',
              userId: match?.userId || this.loggedInUserId,
              companyId: base.companyId || this.loggedInUserCompanyID,
              year: base.year || this.selectedYear,
            };
          });
        }

        console.log('✅ Final dynamicFields:', dynamicFields);

        console.log('Dynamic Fields:', dynamicFields);


        // 🔹 Bind to form
        dynamicFields.forEach((field: any) => {
          if (!this.condidateForm.contains(field.fieldKey)) {
            this.condidateForm.addControl(
              field.fieldKey,
              this.fb.control(field.fieldValue, [Validators.maxLength(255)])
            );
          } else {
            this.condidateForm.get(field.fieldKey)?.patchValue(field.fieldValue);
          }

          this.condidateForm.get(field.fieldKey)?.valueChanges.subscribe(value => {
            field.fieldValue = value;
          });
        });

        this.quetionsList = dynamicFields;
        console.log("✅ Final dynamicFields:", dynamicFields);
        console.log("✅ Form Values:", this.condidateForm.value);
      });
  }





  addSubmitForm: boolean = false;

  isSubmitting = false; // Prevent multiple submissions

  saveexitemloyeedata() {
    console.log(this.quetionsList);

    if (this.isSubmitting) return; // Prevent duplicate API calls

    if (this.condidateForm.invalid) {
      this.addSubmitForm = true;
      this.condidateForm.markAllAsTouched();
      return;
    }
    this.isSubmitting = true; // Set flag to prevent multiple calls

    let formData
    console.log(this.updateEmployeeData);

    formData = {
      "resignationFormId": this.updateEmployeeData?.resignationFormId || null,
      "userId": this.loggedInUserId,
      "companyId": this.loggedInUserCompanyID,
      "empName": this.condidateForm.getRawValue()?.employeeName,
      "empDepartment": this.condidateForm.getRawValue()?.department,
      "empGrade": this.condidateForm.getRawValue()?.grade,
      "empBand": this.condidateForm.getRawValue()?.band,
      "empDesignation": this.condidateForm.getRawValue()?.designation,
      "employmentType": this.condidateForm.getRawValue()?.status,
      "hodCode": this.employeeDataForSave?.hodCode || this.updateEmployeeData?.hodCode,
      "managerCode": this.employeeDataForSave?.reportingManagerCode || this.updateEmployeeData?.managerCode,
      "resignDate": this.condidateForm.getRawValue()?.resignationDate,
      "noticePeriod": this.condidateForm.getRawValue()?.noticePeriod,
      // "lastWorkingDay": this.condidateForm.getRawValue()?.lastWorkingDate,
      "lastWorkingDay": formatDate(this.condidateForm.getRawValue()?.lastWorkingDate),
      "personalMailId": this.condidateForm.getRawValue()?.personalMailId,
      "resignReason": this.condidateForm.getRawValue()?.reasonForExit,
      "resignReasonInDetails": this.condidateForm.getRawValue()?.exitExplanation,
      "contactNo": this.condidateForm.getRawValue()?.contactNumber,
      "withdrawalReason": this.updateEmployeeData?.withdrawalReason || this.condidateForm.value?.withDraw || null,
      "secretReasonForHr": this.condidateForm.getRawValue()?.hiddenReason,
      "withdrawalAccepted": this.updateEmployeeData?.withdrawalAccepted,
      "managerComment": null,
      "hodComment": null,
      "hrComment": null,
      "regretType": null,

      "empCode": this.employeeDataForSave?.emplCode || this.updateEmployeeData?.empCode,
      "hrMail": this.emailOfHrAdmin || this.updateEmployeeData?.hrMail,
      "userOfficialMail": this.employeeDataForSave?.officialEmail || this.updateEmployeeData.userOfficialMail,
      "approvalStatus": "PENDING",
      "fiscalYear": this.loggedInCompanyFiscalyear,
      "year": this.selectedYear,

    };
    let formdataforQuestionField = this.quetionsList;


    this.httpService.callPostService(`${this.config.exitFormSave}`, formData).subscribe(
      (response: any) => {
        if (response) {
          this.httpService.callPostService(`${this.config.saveQusValue}`, formdataforQuestionField).subscribe((e: any) => {
            this.showPopup(response.message, 'success', true);
            this.isSubmitting = false; // Reset flag

          })

        }

      },
      (error: any) => {
        console.log(error.error.m);
        this.showPopup(error.error.message || 'An error occurred.', 'danger', false);
        this.isSubmitting = false; // Reset flag
      }
    );
  }



  saveWithdrawReason(item: any) {
    if (this.isSubmitting) return; // Prevent duplicate API calls
    let formData: any
    if (this.withdrawalReasonCheck == 'withDraw') {
      formData = {
        "resignationFormId": this.updateEmployeeData?.resignationFormId || null,
        "companyId": this.loggedInUserCompanyID,
        "userId": this.updateEmployeeData?.userId,
        "empName": this.updateEmployeeData?.empName,
        "empDepartment": this.updateEmployeeData?.empDepartment,
        "empGrade": this.updateEmployeeData?.empGrade,
        "empBand": this.updateEmployeeData?.empBand,
        "empDesignation": this.updateEmployeeData?.empDesignation,
        "employmentType": this.updateEmployeeData?.employmentType,
        "hodCode": this.updateEmployeeData.hodCode,
        "managerCode": this.updateEmployeeData.managerCode,
        "resignDate": this.updateEmployeeData?.resignDate,
        "noticePeriod": this.updateEmployeeData?.noticePeriod,
        "lastWorkingDay": formatDate(this.updateEmployeeData?.lastWorkingDay),
        "personalMailId": this.updateEmployeeData?.personalMailId,
        "resignReason": this.updateEmployeeData?.resignReason,
        "resignReasonInDetails": this.updateEmployeeData?.resignReasonInDetails,
        "contactNo": this.updateEmployeeData?.contactNo,
        "withdrawalReason": this.condidateForm.value.withDraw || null,
        "secretReasonForHr": this.updateEmployeeData?.secretReasonForHr,
        "managerComment": this.updateEmployeeData?.managerComment || null,
        "hodComment": this.updateEmployeeData?.hodComment || null,
        "hrComment": this.updateEmployeeData?.hrComment || null,
        "regretType": this.updateEmployeeData?.regretType || null,
        "approvalStatus": this.updateEmployeeData?.approvalStatus,
        "fiscalYear": this.loggedInCompanyFiscalyear,
        "userOfficialMail": this.updateEmployeeData?.userOfficialMail,
        // "withdrawalAccepted": this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'MD' ? true : false,
        "withdrawalAccepted": item,
        "empCode": this.updateEmployeeData?.empCode,
        "hrMail": this.updateEmployeeData?.hrMail,
        "year": this.selectedYear,
      }
    }
    let formdataforQuestionField = this.quetionsList;
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: item == true ? 'Are you sure you want to approve ?' : item == null ? 'Are you sure withdraw your resignation ?' : 'Are you sure you want to reject ?',
        btn2: 'Yes',
        btn1: 'No',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.isSubmitting = true;
        this.httpService.callPostService(`${this.config.exitFormSave}`, formData).subscribe(
          (response: any) => {
            this.httpService.callPostService(`${this.config.saveQusValue}`, formdataforQuestionField).subscribe((e: any) => {
              this.showPopup(response.message, 'success', true);
              this.isSubmitting = false; // Reset flag

            })

          },
          (error: any) => {
            this.showPopup(error.error.error || 'An error occurred.', 'danger', false);
            this.isSubmitting = false; // Reset flag
          }
        );
      }
    });

  }

  // Reusable popup function
  showPopup(message: string, color: string, isSuccess: boolean) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: 'OK',
        btn2BgColor: color,
        showSuccessIcon: isSuccess,
        showSuccessMessage: false,
        showCloseIcon: !isSuccess
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      if (isSuccess) this.dialogRef.close(); // Close only on success
    });
  }

}

